
'use client';

import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { cn } from '../lib/utils';
const navItems = [
    { href: '#visas', label: 'Visas' },
    { href: '#why-us', label: 'Why Us' },
    { href: '#faqs', label: 'FAQs' },
    { href: '#travel-guide', label: 'Travel Guide' },
    { href: '#required-docs', label: 'Required Docs' },
    { href: '#dubai-facts', label: 'Dubai Facts' },
];

export function UaeVisaSubNav() {
    const [activeId, setActiveId] = useState('');
    const observer = useRef<IntersectionObserver | null>(null);
    const isClickScrolling = useRef(false);
    const clickTimeout = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const handleObserver = (entries: IntersectionObserverEntry[]) => {
            if (isClickScrolling.current) return;
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setActiveId(entry.target.id);
                }
            });
        };

        observer.current = new IntersectionObserver(handleObserver, {
            rootMargin: '-100px 0px -50% 0px',
        });

        const sections = navItems.map(item => document.querySelector(item.href)).filter(Boolean);
        sections.forEach(section => observer.current?.observe(section!));

        return () => {
            sections.forEach(section => observer.current?.unobserve(section!));
            if (clickTimeout.current) {
                clearTimeout(clickTimeout.current);
            }
        };
    }, []);

    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
        e.preventDefault();
        setActiveId(id);
        isClickScrolling.current = true;
        
        const targetElement = document.getElementById(id);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        if (clickTimeout.current) {
            clearTimeout(clickTimeout.current);
        }

        clickTimeout.current = setTimeout(() => {
            isClickScrolling.current = false;
        }, 1000); 
    };

    return (
        // <nav className="sticky top-24 z-30 mb-8 flex justify-center">
        <nav className="mb-8 flex justify-center">
            <div className="bg-white/90 backdrop-blur-lg p-2 rounded-full border border-gray-200 shadow-sm overflow-x-auto">
                <div className="flex items-center justify-start space-x-1">
                    {navItems.map(item => (
                        <a
                            key={item.label}
                            href={item.href}
                            onClick={(e) => handleNavClick(e, item.href.substring(1))}
                            className={cn(
                                'px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors',
                                activeId === item.href.substring(1)
                                    ? 'bg-primary text-primary-foreground shadow-sm'
                                    : 'text-gray-600 hover:bg-gray-100'
                            )}
                        >
                            {item.label}
                        </a>
                    ))}
                </div>
            </div>
        </nav>
    );
}
